import { AnimatePresence } from 'motion/react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { openSplashPointsInfoFlowEvent } from '@root/entities/splash-point'
import { Drawer } from '@root/shared/ui-kit'

import { SplashPointsInfo } from './splash-points-info'

import type { CurrencyModel } from '@root/entities/currency'

export const SplashPointsInfoDrawer: React.FC = () => {
  const { t } = useTranslation()
  const [currency, setCurrency] = useState<CurrencyModel | undefined>(undefined)

  openSplashPointsInfoFlowEvent.onCall((_, __, [currency]) =>
    setCurrency(currency),
  )

  return (
    <AnimatePresence>
      {currency ? (
        <Root
          open
          title={t('splash-points.doc-title')}
          onOpenChange={() => setCurrency(undefined)}
        >
          <Content>
            <SplashPointsInfo currency={currency} />
          </Content>
        </Root>
      ) : undefined}
    </AnimatePresence>
  )
}

const Root = styled(Drawer)`
  height: var(--max-drawer-height);
  background: var(--background-1);
`

const Content = styled.div`
  height: 100%;
  display: grid;
  min-height: 0;
  overflow: auto;
`
